<glxy-page [mobileMaxWidth]="0">
  <glxy-page-toolbar>
    <glxy-page-nav *ngIf="isBusinessApp">
      <glxy-page-nav-button [useHistory]="true" [previousPageTitle]="'SETTINGS.PAGE_TITLE' | translate">
      </glxy-page-nav-button>
    </glxy-page-nav>

    <glxy-page-nav *ngIf="isPartnerCenter">
      <glxy-page-nav-button [useHistory]="true"></glxy-page-nav-button>
    </glxy-page-nav>
    <glxy-page-title updateTabTitle>{{ 'INBOX.SETTINGS.PAGE_TITLE' | translate }}</glxy-page-title>
    <glxy-page-actions *ngIf="showSaveButton$ | async">
      <button mat-flat-button color="primary" (click)="onSubmit()" [disabled]="loading$ | async">
        {{ 'INBOX.SAVE' | translate }}
      </button>
    </glxy-page-actions>
  </glxy-page-toolbar>

  <glxy-page-wrapper>
    <div class="settings-container">
      <mat-card appearance="outlined" *ngIf="(showAvailabilityMessageSettings$ | async) && isPartnerCenter">
        <mat-card-header>
          <mat-card-title>{{ 'INBOX.SETTINGS.CHAT_AVAILABILITY' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <form [formGroup]="form">
            <glxy-form-field>
              <div>
                <mat-slide-toggle formControlName="showAvailabilityMessage">
                  {{ 'INBOX.SETTINGS.DISPLAY_AVAILABILITY_MESSAGE' | translate }}
                </mat-slide-toggle>
              </div>
              <div class="description">
                {{ 'INBOX.SETTINGS.AVAILABILITY_DESCRIPTION' | translate }}
              </div>
            </glxy-form-field>

            <glxy-form-field>
              <glxy-label>{{ 'INBOX.SETTINGS.AVAILABILITY_MESSAGE' | translate }}</glxy-label>
              <textarea matInput formControlName="availabilityMessage"></textarea>
            </glxy-form-field>
          </form>
          <div>
            <div class="heading">{{ 'INBOX.SETTINGS.PREVIEW_TITLE' | translate }}</div>
            <div>
              <inbox-preview
                [availabilityMessage]="form.value.availabilityMessage ?? ''"
                [showAvailabilityMessage]="form.value.showAvailabilityMessage"
              ></inbox-preview>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card appearance="outlined" *ngIf="isPartnerCenter">
        <mat-card-header>
          <mat-card-title>{{ 'INBOX.SETTINGS.AUTOMATIONS' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="statement">
            {{ 'INBOX.SETTINGS.AUTOMATIONS_DESCRIPTION' | translate }}
            <a
              target="_blank"
              href="https://docs.vendasta.com/docs/automations/my-automations/available-automation-steps"
            >
              {{ 'INBOX.SETTINGS.LEARN_MORE' | translate }}
            </a>
          </div>
          <button mat-flat-button color="primary" (click)="goToAutomations()">
            {{ 'INBOX.SETTINGS.GO_TO_AUTOMATIONS' | translate }}
          </button>
        </mat-card-content>
      </mat-card>

      @if (displayA2pCard$ | async) {
        <inbox-sms-config-card [configuration]="inboxConfiguration$ | async"></inbox-sms-config-card>
      }
      @if (webChatSettingsState$ | async; as state) {
        @if (
          state?.showWebChats === true ||
          state?.showCreateWebChatCtaCard === true ||
          state?.showLocalSeoCtaCard === true
        ) {
          <inbox-webchat-config-card
            [webchats]="formWebchats$ | async"
            [showWebChatUpgradeModal]="state?.showWebChatUpgradeModal"
            [canShowMyListingsCTA]="state?.showLocalSeoCtaOnExisting"
            [showCreateWebChatCTA]="state?.showCreateWebChatCtaCard"
            [goToMyListingUrl]="state?.showLocalSeoCtaCard ? state?.localSEOListingUrl : ''"
          ></inbox-webchat-config-card>
        }
      }

      @if (canAccessEmailChannel) {
        <inbox-email-settings-card></inbox-email-settings-card>
      }

      @if (facebookMessengerAvailable$ | async) {
        <inbox-facebook-messenger
          [accountID]="(accountGroupId$ | async) ?? ''"
          [partnerID]="(partnerId$ | async) ?? ''"
        ></inbox-facebook-messenger>
      }

      @if (instagramMessagesAvailable$ | async) {
        <inbox-instagram-messages
          [accountID]="(accountGroupId$ | async) ?? ''"
          [partnerID]="(partnerId$ | async) ?? ''"
        ></inbox-instagram-messages>
      }

      @if (whatsAppMessagesAvailable$ | async) {
        <inbox-whatsapp-config
          [accountID]="(accountGroupId$ | async) ?? ''"
          [partnerID]="(partnerId$ | async) ?? ''"
        ></inbox-whatsapp-config>
      }

      @if (canAccessPlatformAssistantSettingsCard()) {
        <inbox-platform-assistant-config-card></inbox-platform-assistant-config-card>
      }

      <mat-card appearance="outlined">
        <mat-card-header>
          <mat-icon mat-card-avatar class="template"></mat-icon>
          <mat-card-title class="card-title">{{ 'INBOX.SETTINGS.MESSAGE_TEMPLATES.TITLE' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="statement">{{ 'INBOX.SETTINGS.MESSAGE_TEMPLATES.DESCRIPTION' | translate }}</div>
          <button mat-flat-button color="primary" (click)="goToTemplatePage()">
            {{ 'INBOX.SETTINGS.MESSAGE_TEMPLATES.GO_TO_MESSAGE_TEMPLATES' | translate }}
          </button>
        </mat-card-content>
      </mat-card>
    </div>
  </glxy-page-wrapper>

  <ng-container *ngIf="displayEmptyState$ | async">
    <ng-container *ngTemplateOutlet="emptyState"></ng-container>
  </ng-container>
</glxy-page>

<ng-template #emptyState>
  <glxy-empty-state class="empty-state">
    <glxy-empty-state-hero>
      <div class="empty-state-image"></div>
    </glxy-empty-state-hero>
    <glxy-empty-state-title>{{ 'INBOX.SETTINGS.EMPTY_STATE.TITLE' | translate }}</glxy-empty-state-title>
    <p>{{ 'INBOX.SETTINGS.EMPTY_STATE.DESCRIPTION' | translate }}</p>
  </glxy-empty-state>
</ng-template>
